"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCommittedValue = exports.setChildPartValue = exports.removePart = exports.isTemplateResult = exports.isSingleExpression = exports.isPrimitive = exports.isDirectiveResult = exports.isCompiledTemplateResult = exports.insertPart = exports.getDirectiveClass = exports.getCommittedValue = exports.clearPart = exports.TemplateResultType = void 0;

var _litHtml = require("./lit-html.js");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var t = _litHtml._$LH.D,
    i = function i(o) {
  return null === o || "object" != _typeof(o) && "function" != typeof o;
},
    n = {
  HTML: 1,
  SVG: 2
},
    e = function e(o, t) {
  return void 0 === t ? void 0 !== (o === null || o === void 0 ? void 0 : o._$litType$) : (o === null || o === void 0 ? void 0 : o._$litType$) === t;
},
    l = function l(o) {
  var _o$_$litType$;

  return null != (o === null || o === void 0 ? void 0 : (_o$_$litType$ = o._$litType$) === null || _o$_$litType$ === void 0 ? void 0 : _o$_$litType$.h);
},
    c = function c(o) {
  return void 0 !== (o === null || o === void 0 ? void 0 : o._$litDirective$);
},
    d = function d(o) {
  return o === null || o === void 0 ? void 0 : o._$litDirective$;
},
    f = function f(o) {
  return void 0 === o.strings;
},
    s = function s() {
  return document.createComment("");
},
    r = function r(o, i, n) {
  var e = o._$AA.parentNode,
      l = void 0 === i ? o._$AB : i._$AA;

  if (void 0 === n) {
    var _i = e.insertBefore(s(), l),
        _c = e.insertBefore(s(), l);

    n = new t(_i, _c, o, o.options);
  } else {
    var _t = n._$AB.nextSibling,
        _i2 = n._$AM,
        _c2 = _i2 !== o;

    if (_c2) {
      var _n$_$AQ, _n;

      var _t2;

      (_n$_$AQ = (_n = n)._$AQ) !== null && _n$_$AQ !== void 0 && _n$_$AQ.call(_n, o), n._$AM = o, void 0 !== n._$AP && (_t2 = o._$AU) !== _i2._$AU && n._$AP(_t2);
    }

    if (_t !== l || _c2) {
      var _o = n._$AA;

      for (; _o !== _t;) {
        var _t3 = _o.nextSibling;
        e.insertBefore(_o, l), _o = _t3;
      }
    }
  }

  return n;
},
    v = function v(o, t) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : o;
  return o._$AI(t, i), o;
},
    u = {},
    m = function m(o) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : u;
  return o._$AH = t;
},
    p = function p(o) {
  return o._$AH;
},
    h = function h(o) {
  var _o$_$AP;

  (_o$_$AP = o._$AP) === null || _o$_$AP === void 0 ? void 0 : _o$_$AP.call(o, !1, !0);
  var t = o._$AA;
  var i = o._$AB.nextSibling;

  for (; t !== i;) {
    var _o2 = t.nextSibling;
    t.remove(), t = _o2;
  }
},
    j = function j(o) {
  o._$AR();
};

exports.clearPart = j;
exports.removePart = h;
exports.getCommittedValue = p;
exports.setCommittedValue = m;
exports.setChildPartValue = v;
exports.insertPart = r;
exports.isSingleExpression = f;
exports.getDirectiveClass = d;
exports.isDirectiveResult = c;
exports.isCompiledTemplateResult = l;
exports.isTemplateResult = e;
exports.TemplateResultType = n;
exports.isPrimitive = i;